export default __webpack_public_path__ + "static/media/michaeloxendine.6d8d3ce2.png";